import { usePageScrollRestoration } from "@client/hooks/use-page-scroll-restoration";
import { useRef, type ReactNode } from "react";
import { useLocation } from "wouter";
import { RouteScroller } from "./RouteScroller";

/**
 * Page scroller shared by round pages and workspace subviews. Back/Forward
 * returns to the reader's saved position. Keying by pathname starts a new
 * page at the top instead of inheriting a sibling route's scroll offset.
 */
export function RestoredScrollPane({
  roundId,
  children,
}: {
  roundId: string;
  children: ReactNode;
}) {
  const [pathname] = useLocation();
  const scrollerRef = useRef<HTMLDivElement | null>(null);
  usePageScrollRestoration({
    roundId,
    getContainer: () => scrollerRef.current,
  });
  return (
    <RouteScroller key={pathname} ref={scrollerRef}>
      {children}
    </RouteScroller>
  );
}
